module.exports = __webpack_public_path__ + "img/pick2.465da155.png";